import xlsx from "xlsx";
import { saveAs } from "file-saver";
import { normalizeDateForExport } from "./dateFormat";
const execelExtension = ".xlsx";
const execelType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export default function (data, name, headers, secondData, secondHeaders, sheetNames) {
  if (headers) {
    data = mapHeaders(data, headers);
  }
  if (secondData && secondHeaders) {
    secondData = mapHeaders(secondData, secondHeaders);
  }

  data = normalizeRows(sanitizeRows(data));
  if (secondData) {
    secondData = normalizeRows(sanitizeRows(secondData));
  }

  const firstSheetName = normalizeSheetName(sheetNames?.first, "data");
  const secondSheetName = normalizeSheetName(sheetNames?.second, "data2", firstSheetName);
  const worksheet = xlsx.utils.json_to_sheet(data);
  const workbook = {
    Sheets: {
      [firstSheetName]: worksheet,
    },
    SheetNames: [firstSheetName],
  };

  if (secondData) {
    const worksheet2 = xlsx.utils.json_to_sheet(secondData);
    workbook.Sheets[secondSheetName] = worksheet2;
    workbook.SheetNames.push(secondSheetName);
  }

  const execelBuffer = xlsx.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  savefile(execelBuffer, name);
}

function savefile(buffer, filename) {
  const data = new Blob([buffer], { type: execelType });
  saveAs(data, filename + "_export_" + new Date().getTime() + execelExtension);
}

function mapHeaders(values, headers) {
  return values.map((value) => {
    return headers.reduce((acc, header) => {
      return { ...acc, [header.text]: value[header.value] };
    }, {});
  });
}

function normalizeSheetName(name, fallbackName = "data", usedName = null) {
  const normalized = String(name || fallbackName)
    .replace(/[:\\/?*[\]]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  const sheetName = normalized || fallbackName;
  const safeName = sheetName.slice(0, 31);
  return usedName && safeName === usedName ? `${safeName} 2`.slice(0, 31) : safeName;
}

function normalizeRows(rows) {
  return rows.map((row) =>
    Object.keys(row).reduce((acc, key) => {
      const normalizedValue = normalizeExportValue(row[key]);
      return { ...acc, [key]: normalizedValue };
    }, {})
  );
}

function normalizeExportValue(value) {
  const dateValue = normalizeDateForExport(value);

  if (dateValue !== value) {
    return dateValue;
  }

  return convertNumericStringToNumber(value);
}

function convertNumericStringToNumber(value) {
  if (typeof value === "string") {
    const cleaned = value.replace(/\./g, "").replace(",", ".");
    const parsed = Number(cleaned);

    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return value;
}

function sanitizeRows(values) {
  const maxLength = 32767;
  return values.map((row) => {
    return Object.keys(row).reduce((acc, key) => {
      const value = row[key];
      acc[key] = sanitizeValue(value, maxLength);
      return acc;
    }, {});
  });
}

function sanitizeValue(value, maxLength) {
  if (value === null || value === undefined) {
    return "";
  }

  const dateValue = normalizeDateForExport(value);
  if (dateValue !== value) {
    return dateValue;
  }

  if (typeof value === "number") {
    return value;
  }

  const normalized =
    typeof value === "object" ? JSON.stringify(value) : String(value);
  if (normalized.length <= maxLength) {
    return normalized;
  }

  const ellipsis = "...";
  return normalized.slice(0, maxLength - ellipsis.length) + ellipsis;
}
